/**
 * @file psd/parser.ts
 * @description Pure parsing logic for PSD files.
 */

import { PSDInstance } from './types';

declare const PSD: any;
declare const psd: any;
declare const agPsd: any;

/**
 * Loads a PSD file from an ArrayBuffer.
 */
export async function loadPsdFile(arrayBuffer: ArrayBuffer): Promise<PSDInstance | null> {
  const Lib = typeof PSD !== 'undefined' ? PSD : (typeof psd !== 'undefined' ? psd : null);
  
  if (!Lib) {
    console.error('PSD library (psd.js) not loaded.');
    return null;
  }

  try {
    const uint8 = new Uint8Array(arrayBuffer);
    const psdObj = new Lib(uint8);
    
    if (!psdObj.parse()) {
      console.warn('PSD.js failed to parse. Trying ag-psd...');
      throw new Error('PSD.js parse failure');
    }
    
    console.log('PSD loaded via psd.js');
    return psdObj;
  } catch (err) {
    if (typeof agPsd !== 'undefined') {
        try {
            console.log('[PSD] Attempting read with ag-psd...');
            const data = agPsd.readPsd(arrayBuffer);
            return { __isAgPsd: true, data } as PSDInstance;
        } catch (e) {
            console.error('ag-psd also failed to read:', e);
        }
    }
    console.error(`Error reading PSD: ${(err as Error).message}`, err);
    return null;
  }
}
